"use client";
import type { ReactElement } from "react";
import { getFontFamily } from "@/theme/typography";
export interface GanttTooltipDurationProps {
    durationDays: number;
}
export function GanttTooltipDuration({ durationDays, }: GanttTooltipDurationProps): ReactElement {
    return (
      <div style={{
            fontFamily: getFontFamily(),
            fontSize: 11,
            color: "rgba(255,255,255,0.6)",
            lineHeight: "15px",
            marginTop: 2,
        }}>
      Duration: {durationDays} day{durationDays === 1 ? "" : "s"}
      </div>
    );
}
